import { useTranslation } from 'react-i18next';

import { Divider, Stack } from '@mui/material';

import Typography from '../../components/Typography';
import { i18nNS } from '../../i18n';
import AttendanceTile from '../../modules/class/Attendance/AttendanceTile';
import BarGraphTile from '../../modules/poll/Tiles/BarGraph/BarGraphTile';
import PieChartTile from '../../modules/poll/Tiles/PieChart/PieChartTile';
import TimerTile from '../../modules/timer/Timer/TimerTile';
import Header from './Header';
import { Root } from './styles';
import useHome from './vm';

const HomePage = () => {
  const { t } = useTranslation();
  useHome();

  return (
    <Root>
      <Header />
      <Divider />
      <Stack gap={4}>
        <Typography variant="h4Regular" color="common.black" component="div">
          {t('which_activity_do_you_want_to_add_to_this_slide', { ns: i18nNS.HOME })}
        </Typography>
        <Typography
          variant="paragraphBold"
          color="common.black"
          fontSize={18}
          component="h2"
          textTransform="uppercase"
        >
          {t('poll', { ns: i18nNS.GLOSSARY })}
        </Typography>
        <Stack direction="row" alignItems="center" gap={0.5} p={1.25}>
          {/* <QuickPollTile /> */}
          <BarGraphTile />
          <PieChartTile />
          {/* <Tile
            icon={WordCloudWhiteIcon}
            hoverIcon={WordCloudIcon}
            title={t('wordcloud', { ns: i18nNS.GLOSSARY })}
            onClick={() => {}}
            isActive={false}
          /> */}
        </Stack>
        <Typography
          variant="paragraphBold"
          color="common.black"
          fontSize={18}
          component="h2"
          textTransform="uppercase"
        >
          {t('other', { ns: i18nNS.GLOSSARY })}
        </Typography>
        <Stack direction="row" alignItems="center" gap={0.5} p={1.25}>
          <AttendanceTile />
          <TimerTile />
        </Stack>
      </Stack>
    </Root>
  );
};

export default HomePage;
